export const apiRoutes = {
  userInfo: '/service/segmentation/v2/user/info'
};
